import useTableFiltersHook from "./useTableFiltersHook";
import * as Styled from "./Table.styles";
import { TableHeadProps } from "./types";
import { memo, useEffect } from "react";
import Checkbox from "@/Components/Checkbox/Checkbox";
import Rotate from "./Rotate";
import { useTranslation } from "react-i18next";
import { defaultTableSortAtom } from "@/shared/atoms";
import { useAtom } from "jotai";
import Tooltip from "@/Components/Tooltip/Tooltip";

const TableHead = ({
  columns,
  tableName,
  disableSort = false,
  isAllActived = false,
  disableAction = false,
  setAll
}: TableHeadProps) => {
  const { t } = useTranslation();
  const { handleColumnClick, getSort } = useTableFiltersHook(tableName);
  const [defaultTableSort, setDefaultTableSort] = useAtom(defaultTableSortAtom);

  useEffect(() => {
    const isDefaultTableSortApplied = defaultTableSort[tableName] === true;
    if (!isDefaultTableSortApplied) {
      setTimeout(() => {
        columns.forEach((column) => {
          const hasDefaultSortValue = column.defaultSortValue !== undefined;
          if (hasDefaultSortValue) {
            setDefaultTableSort({ [tableName]: true });
            const value =
            column.defaultSortValue === "DESC" ||
            column.defaultSortValue === "DESC_NUMERIC" ?
            true :
            false;
            handleColumnClick(column, value);
          }
        });
      }, 50);
    }
  }, [columns]);

  return (
    <Styled.Thead>
      <tr>
        {!disableAction &&
        <Styled.Th>
            <Checkbox
            active={isAllActived || false}
            onChange={() => setAll()}
            sizing={"mini"} />
          
          </Styled.Th>
        }
        {columns.
        filter((column) => !column.disable).
        map((column) => {
          const sort =
          !disableSort && !column.disableSort && getSort(column.id);

          return (
            <Styled.Th key={column.id}>
                <Tooltip content=

              {
              disableSort || column.disableSort ?
              undefined :
              t("clickToSort")
              }><div><div
                    className="flex"
                    style={{
                      cursor: disableSort || column.disableSort ? "unset" : "pointer",
                    }}
                    onClick={() =>
                    !disableSort &&
                    !column.disableSort &&
                    handleColumnClick(column)
                    }>
                    
                  {column.Header}
                  <div
                      className="ml-4 flex items-center"
                      style={{
                        opacity: !disableSort && !column.disableSort ? 1 : 0,
                        transition: "all 300ms",
                      }}>
                      
                    <Rotate
                        degrees={
                        sort?.value === "DESC" || sort?.value === "DESC_NUMERIC" ?
                        "0deg" :
                        "180deg"
                        }
                        fill="white"
                        variants="arrow"
                        size="1.5rem" />
                      
                    <Rotate
                        opacity={sort !== undefined ? 0 : 1}
                        degrees={"360deg"}
                        fill="white"
                        variants="arrow"
                        size="1.5rem" />
                      
                  </div>
                </div></div></Tooltip>
              </Styled.Th>);

        })}
      </tr>
    </Styled.Thead>);

};

export default memo(TableHead);